import React from 'react';
import { ShieldIcon, TrophyIcon, FlameIcon, CheckIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function RacingClasses() {
  const {
    t
  } = useLanguage();
  return <section id="classes" className="w-full bg-neutral-950 bg-noise py-20 md:py-28 px-4" data-id="element-462">
      <div className="max-w-7xl mx-auto" data-id="element-463">
        {/* Section Header */}
        <div className="text-center mb-16" data-id="element-464">
          <p className="text-orange-500 font-semibold text-sm uppercase tracking-[0.3em] mb-3" data-id="element-465">
            {t('classes.chooseChallenge')}
          </p>
          <h2 className="font-display text-4xl md:text-6xl tracking-wider text-white mb-4" data-id="element-466">
            {t('classes.title')}
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-467">
            {t('classes.subtitle')}
          </p>
        </div>

        {/* Classes Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8" data-id="element-468">
          {/* Beginner Class */}
          <div className="relative group bg-neutral-900 border border-neutral-800 rounded-2xl overflow-hidden hover:border-green-500/50 transition-all duration-300" data-id="element-469">
            <div className="absolute top-0 left-0 right-0 h-1 bg-green-500" aria-hidden="true" data-id="element-470" />
            <div className="p-8" data-id="element-471">
              <div className="w-14 h-14 rounded-xl bg-green-500/10 flex items-center justify-center mb-6" data-id="element-472">
                <ShieldIcon className="h-7 w-7 text-green-500" data-id="element-473" />
              </div>
              <h3 className="font-display text-3xl tracking-wider text-white mb-2" data-id="element-474">
                {t('classes.beginner')}
              </h3>
              <p className="text-gray-400 mb-6" data-id="element-475">{t('classes.beginnerDesc')}</p>

              {/* Price */}
              <div className="mb-6" data-id="element-476">
                <span className="text-4xl font-bold text-white" data-id="element-477">€100</span>
                <span className="text-gray-500 ml-2" data-id="element-478">
                  {t('classes.perRider')}
                </span>
                <p className="text-green-500 text-sm font-semibold mt-1" data-id="element-479">
                  {t('classes.earlyBird')}
                </p>
              </div>

              {/* Requirements */}
              <div className="space-y-3 mb-8" data-id="element-480">
                <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2" data-id="element-481">
                  {t('classes.requirements')}
                </p>
                <div className="flex items-start gap-3" data-id="element-482"></div>
                <div className="flex items-start gap-3" data-id="element-483">
                  <CheckIcon className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-484" />
                  <span className="text-gray-300 text-sm" data-id="element-485">
                    {t('classes.beginnerReq1')}
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-486">
                  <CheckIcon className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-487" />
                  <span className="text-gray-300 text-sm" data-id="element-488">
                    {t('classes.beginnerReq2')}
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-489">
                  <CheckIcon className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-490" />
                  <span className="text-gray-300 text-sm" data-id="element-491">
                    {t('classes.beginnerReq3')}
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-492">
                  <CheckIcon className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-493" />
                  <span className="text-gray-300 text-sm" data-id="element-494">
                    {t('classes.beginnerReq4')}
                  </span>
                </div>
              </div>

              {/* Details */}
              <div className="bg-neutral-800/50 rounded-xl p-4 mb-4" data-id="element-495">
                <div className="grid grid-cols-2 gap-4 text-center" data-id="element-496">
                  <div data-id="element-497">
                    <p className="text-2xl font-bold text-white" data-id="element-498">10 km</p>
                    <p className="text-xs text-gray-500 uppercase" data-id="element-499">
                      {t('classes.distance')}
                    </p>
                  </div>
                  <div data-id="element-500">
                    <p className="text-2xl font-bold text-white" data-id="element-501">3 st.</p>
                    <p className="text-xs text-gray-500 uppercase" data-id="element-502">
                      {t('classes.timeLimit')}
                    </p>
                  </div>
                </div>
              </div>
              <p className="text-xs text-gray-500 italic" data-id="element-503">
                {t('classes.scoringRule')}
              </p>
            </div>
          </div>

          {/* Hobby Class */}
          <div className="relative group bg-neutral-900 border border-neutral-800 rounded-2xl overflow-hidden hover:border-orange-500/50 transition-all duration-300 md:scale-105 md:shadow-2xl" data-id="element-504">
            <div className="absolute top-0 left-0 right-0 h-1 bg-orange-500" aria-hidden="true" data-id="element-505" />
            <div className="absolute top-4 right-4" data-id="element-506">
              <span className="px-3 py-1 bg-orange-500 text-black text-xs font-bold uppercase rounded-full" data-id="element-507">
                {t('classes.popular')}
              </span>
            </div>
            <div className="p-8" data-id="element-508">
              <div className="w-14 h-14 rounded-xl bg-orange-500/10 flex items-center justify-center mb-6" data-id="element-509">
                <TrophyIcon className="h-7 w-7 text-orange-500" data-id="element-510" />
              </div>
              <h3 className="font-display text-3xl tracking-wider text-white mb-2" data-id="element-511">
                {t('classes.hobby')}
              </h3>
              <p className="text-gray-400 mb-6" data-id="element-512">{t('classes.hobbyDesc')}</p>

              {/* Price */}
              <div className="mb-6" data-id="element-513">
                <span className="text-4xl font-bold text-white" data-id="element-514">€100</span>
                <span className="text-gray-500 ml-2" data-id="element-515">
                  {t('classes.perRider')}
                </span>
                <p className="text-green-500 text-sm font-semibold mt-1" data-id="element-516">
                  {t('classes.earlyBird')}
                </p>
              </div>

              {/* Requirements */}
              <div className="space-y-3 mb-8" data-id="element-517">
                <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2" data-id="element-518">
                  {t('classes.requirements')}
                </p>
                <div className="flex items-start gap-3" data-id="element-519"></div>
                <div className="flex items-start gap-3" data-id="element-520">
                  <CheckIcon className="h-5 w-5 text-orange-500 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-521" />
                  <span className="text-gray-300 text-sm" data-id="element-522">
                    {t('classes.hobbyReq1')}
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-523">
                  <CheckIcon className="h-5 w-5 text-orange-500 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-524" />
                  <span className="text-gray-300 text-sm" data-id="element-525">
                    {t('classes.hobbyReq2')}
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-526">
                  <CheckIcon className="h-5 w-5 text-orange-500 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-527" />
                  <span className="text-gray-300 text-sm" data-id="element-528">
                    {t('classes.hobbyReq3')}
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-529">
                  <CheckIcon className="h-5 w-5 text-orange-500 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-530" />
                  <span className="text-gray-300 text-sm" data-id="element-531">
                    {t('classes.hobbyReq4')}
                  </span>
                </div>
              </div>

              {/* Details */}
              <div className="bg-neutral-800/50 rounded-xl p-4 mb-4" data-id="element-532">
                <div className="grid grid-cols-2 gap-4 text-center" data-id="element-533">
                  <div data-id="element-534">
                    <p className="text-2xl font-bold text-white" data-id="element-535">12 km</p>
                    <p className="text-xs text-gray-500 uppercase" data-id="element-536">
                      {t('classes.distance')}
                    </p>
                  </div>
                  <div data-id="element-537">
                    <p className="text-2xl font-bold text-white" data-id="element-538">3 st.</p>
                    <p className="text-xs text-gray-500 uppercase" data-id="element-539">
                      {t('classes.timeLimit')}
                    </p>
                  </div>
                </div>
              </div>
              <p className="text-xs text-gray-500 italic" data-id="element-540">
                {t('classes.scoringRule')}
              </p>
            </div>
          </div>

          {/* Pro Class */}
          <div className="relative group bg-neutral-900 border border-neutral-800 rounded-2xl overflow-hidden hover:border-red-500/50 transition-all duration-300" data-id="element-541">
            <div className="absolute top-0 left-0 right-0 h-1 bg-red-500" aria-hidden="true" data-id="element-542" />
            <div className="p-8" data-id="element-543">
              <div className="w-14 h-14 rounded-xl bg-red-500/10 flex items-center justify-center mb-6" data-id="element-544">
                <FlameIcon className="h-7 w-7 text-red-500" data-id="element-545" />
              </div>
              <h3 className="font-display text-3xl tracking-wider text-white mb-2" data-id="element-546">
                {t('classes.pro')}
              </h3>
              <p className="text-gray-400 mb-6" data-id="element-547">{t('classes.proDesc')}</p>

              {/* Price */}
              <div className="mb-6" data-id="element-548">
                <span className="text-4xl font-bold text-white" data-id="element-549">€100</span>
                <span className="text-gray-500 ml-2" data-id="element-550">
                  {t('classes.perRider')}
                </span>
                <p className="text-green-500 text-sm font-semibold mt-1" data-id="element-551">
                  {t('classes.earlyBird')}
                </p>
              </div>

              {/* Requirements */}
              <div className="space-y-3 mb-8" data-id="element-552">
                <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2" data-id="element-553">
                  {t('classes.requirements')}
                </p>
                <div className="flex items-start gap-3" data-id="element-554"></div>
                <div className="flex items-start gap-3" data-id="element-555">
                  <CheckIcon className="h-5 w-5 text-red-500 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-556" />
                  <span className="text-gray-300 text-sm" data-id="element-557">
                    {t('classes.proReq1')}
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-558">
                  <CheckIcon className="h-5 w-5 text-red-500 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-559" />
                  <span className="text-gray-300 text-sm" data-id="element-560">
                    {'Pilns sacens\u012Bbu ekip\u0113jums ar ieteicamu kakla aizsargu'}
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-561">
                  <CheckIcon className="h-5 w-5 text-red-500 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-562" />
                  <span className="text-gray-300 text-sm" data-id="element-563">
                    {t('classes.proReq3')}
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-564">
                  <CheckIcon className="h-5 w-5 text-red-500 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-565" />
                  <span className="text-gray-300 text-sm" data-id="element-566">
                    {t('classes.proReq4')}
                  </span>
                </div>
              </div>

              {/* Details */}
              <div className="bg-neutral-800/50 rounded-xl p-4 mb-4" data-id="element-567">
                <div className="grid grid-cols-2 gap-4 text-center" data-id="element-568">
                  <div data-id="element-569">
                    <p className="text-2xl font-bold text-white" data-id="element-570">13 km</p>
                    <p className="text-xs text-gray-500 uppercase" data-id="element-571">
                      {t('classes.distance')}
                    </p>
                  </div>
                  <div data-id="element-572">
                    <p className="text-2xl font-bold text-white" data-id="element-573">3 st.</p>
                    <p className="text-xs text-gray-500 uppercase" data-id="element-574">
                      {t('classes.timeLimit')}
                    </p>
                  </div>
                </div>
              </div>
              <p className="text-xs text-gray-500 italic" data-id="element-575">
                {t('classes.scoringRule')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}